import { HttpService } from '~/helpers';
import { UserService } from '~/services';

const endpoint = 'portal/mensagem';

const formatValues = values => ({
  ...values,
  usuario: UserService.getUser().login,
  cliente: UserService.getUser().codigo,
});

const FrequenciaService = {
  getAll: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAll', [formatValues(values)], onSuccess, onError);
  },
  getAllPlaca: (onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllPlaca', [UserService.getUser().codigo], onSuccess, onError);
  },
  salvar: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'salvar', [formatValues(values)], onSuccess, onError);
  },
  excluir: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'excluir', [values.id, UserService.getUser().codigo], onSuccess, onError);
  },
};

export default FrequenciaService;
